@if (open()) {
<div class="modal-backdrop fade show"></div>

<div
  class="modal fade show d-block"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-sm">
      <div class="modal-header border-0">
        <h5 class="modal-title">
          {{ title() }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="onCancel()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <app-validated-input
            [inputFormControl]="form.controls.email"
            inputFormControlName="email"
            label="general.email"
            [leaveSpaceForValidation]="true"
          />

          <div class="row">
            <div class="col-sm-6 gap-2">
              <app-validated-input
                [inputFormControl]="form.controls.password"
                inputFormControlName="password"
                label="general.password"
                [leaveSpaceForValidation]="true"
              />
            </div>
            <div class="col-sm-6">
              <app-validated-input
                [inputFormControl]="form.controls.confirmPassword"
                inputFormControlName="confirmPassword"
                label="general.repeatPassword"
                [leaveSpaceForValidation]="true"
              />
            </div>
          </div>

          <hr class="border-300" />

          <app-validated-dropdown
            [inputFormControl]="form.controls.titleCode"
            inputFormControlName="titleCode"
            label="general.nameTitle"
            [leaveSpaceForValidation]="true"
            [loading]="!store.allLoaded() || store.nameTitlesEntities().length === 0"
            [optionsStamp]="store.nameTitlesEntities().length"
          >
            <option value="">—</option>
            <option
              *ngFor="let type of store.nameTitlesEntities()"
              [value]="type.code"
            >
              {{ type.localized | getLocalized }}
            </option>
          </app-validated-dropdown>

          <app-validated-input
            [inputFormControl]="form.controls.lastName"
            inputFormControlName="lastName"
            label="general.lastName"
            [leaveSpaceForValidation]="true"
          />

          <app-validated-input
            [inputFormControl]="form.controls.middleName"
            inputFormControlName="middleName"
            label="general.middleName"
            [leaveSpaceForValidation]="true"
          />

          <app-validated-input
            [inputFormControl]="form.controls.firstName"
            inputFormControlName="firstName"
            label="general.firstName"
            [leaveSpaceForValidation]="true"
          />

          <app-validated-input
            [inputFormControl]="form.controls.phoneNumber"
            inputFormControlName="phoneNumber"
            label="general.phone"
            [leaveSpaceForValidation]="true"
          />
        </form>
      </div>

      <div class="modal-footer border-0">
        <app-button
          type="button"
          variant="default"
          [label]="'general.cancel' | translate"
          (click)="onCancel()"
        />
        <app-button
          type="submit"
          [label]="'general.add' | translate"
          btnClass="btn btn-primary btn-sm"
          [disabled]="form.invalid || submitting()"
          [loading]="submitting()"
          (clicked)="onSubmit()"
        />
      </div>
    </div>
  </div>
</div>
}
